import styled from '@emotion/styled'

export const TitleStyle = styled.div`
  .section-title {
    font-size: 24px;
    color: var(--foreground);
  }
`
